export default {
  name: 'empty',
  props: {
    onlyShowSelected: {
      default: 0
    }
  },
  data: function data() {
    return {};
  },
  methods: {}
};